/* eslint-disable react/prop-types */
import { Button, Collapse, Divider, Empty, Flex, Popover, Spin, theme, Typography } from 'antd';
import React, { useEffect, useMemo, useRef, useState } from 'react';

// import { Button } from '../../../../styleguide';
import { createNotificationLink, generateDescription, generateTitle, getType, privacyRiskContent, defaulFilterObj } from '../helpers';
import { NotificationDetailsPage } from './NotificationDetails';
import FilterPanel from './FilterPanel';
import { FilterFilled, InfoCircleOutlined } from '@ant-design/icons';
import FilterTags from './FilterTags';
import { usePrevious } from '../../../../hooks';
const { useToken } = theme;


const { Text } = Typography;

const NotificationTabItem = ({
  activeTab,
  isLoading,
  isLoadingMore,
  result = {},
  getAdditionalData,
  markNotificationsRead,
  alertTypes,
  metrics,
  onApplyFilters, 
  appliedFilters,
}) => {
const [isUpdating, setUpdating] = useState(false);
const [activeCollapse, setActiveCollapse] = useState([]);
const [isFilterCollapsed, setIsFilterCollapsed] = useState(false);
const {token} = useToken();
const { count, page, ...notificationData } = result;

const [filtersEverApplied, setFiltersEverApplied] = useState(false);
const isAnyFilterApplied = useMemo(() => {
  const hasFilters = Object.values(appliedFilters).some((val) =>
    Array.isArray(val) ? val.length > 0 : !!val
  );

  if (hasFilters && !filtersEverApplied) {
    setFiltersEverApplied(true);
  }

  return hasFilters;
}, [appliedFilters, filtersEverApplied]);

const isNotificationDataEmpty = !notificationData || Object.keys(notificationData).length === 0;
const shouldShowUI = !isNotificationDataEmpty || isAnyFilterApplied || filtersEverApplied;
  
const handleToggle = () => {
  setIsFilterCollapsed(!isFilterCollapsed);
};

const scrollRef = useRef(0);
const prevResult = usePrevious(result)
let containerHeight = useMemo(() => window.innerHeight * 0.9,[window.innerHeight]); 
const collapseDiv = document.querySelector(
  '#alerts-list-container .ant-spin-container'
);
if (collapseDiv) {
  collapseDiv.style.height = `${containerHeight + 10}px`;
}


const onScroll = (e) => {
  const containerCurrentPosition = e.currentTarget.scrollHeight - e.currentTarget.scrollTop;
  if (
    scrollRef.current <= e.currentTarget.scrollTop &&
    !isLoadingMore &&
    containerCurrentPosition <= containerHeight + 200
  ) {
    getAdditionalData();
  }
  scrollRef.current = e.currentTarget.scrollTop;

};

useEffect(() => {
  const sticky1 = document.querySelectorAll('.tab-content_wrapper .tab-actions_container')[0];
  const sticky2 = document.querySelectorAll('.collapse-wrapper .ant-collapse-header');
  const outer = document.getElementsByClassName('spt-content')[0];
  const inner = document.getElementById('alerts-list-container');
  function updateSticky2Position() {
    const innerRect = inner.getBoundingClientRect();
    const sticky1Rect = sticky1.getBoundingClientRect();

    const innerTop = innerRect.top + 60;
    const innerBottom = innerRect.bottom;
    if(sticky2?.length) {
      for (var el of sticky2) {
        const sticky2Height = el.offsetHeight;

        const shouldStickToOuter =
          innerTop <= sticky1Rect.bottom &&
          innerBottom > sticky1Rect.bottom + sticky2Height;

        if (shouldStickToOuter) {
          el.classList.add('sticking-outer');
        } else {
          el.classList.remove('sticking-outer');
        }
      }
    }
  }

  outer.addEventListener('scroll', updateSticky2Position);
  inner.addEventListener('scroll', updateSticky2Position);

  return () => {
    outer.removeEventListener('scroll', updateSticky2Position);
    inner.removeEventListener('scroll', updateSticky2Position);
  };
}, [result]);


useEffect(() => {
  const currentKeys = Object.keys(notificationData);
  const { count, page, ...prevNotificationData } = prevResult || {};
  const prevKeys = Object.keys(prevNotificationData);

  const newActiveKeys = currentKeys.filter(key => !prevKeys.includes(key));
  const latestKey = currentKeys[currentKeys.length - 1];

  if (newActiveKeys.length > 0 || latestKey) {
    setActiveCollapse(prev => {
      const updated = new Set([...(prev || []), ...newActiveKeys, latestKey]);
      return Array.from(updated);
    });
  }
}, [result]);

const onMarkAll = async () => {
  setUpdating(true);
  await markNotificationsRead({ read_all: true }, { refetchList: true });
  setUpdating(false);
};

  return (
    <>
      <div className='tab-content_wrapper'>
        {/* Top actions */}
        <div className="tab-actions_container">
          {shouldShowUI && (
            <Flex align="center" gap={token.marginSM}>
              <Button
                type="text"
                size="small"
                icon={<FilterFilled style={{ color: token.colorTextDisabled }} />}
                onClick={handleToggle}
              />
              <Text>Filter</Text>
              <FilterTags
                filters={appliedFilters}
                alertTypes={alertTypes}
              />
            </Flex>
          )}

          {!isNotificationDataEmpty && activeTab === 'new' && (
            <div className="tab-actions_risk">
              <Flex align="center" gap={token.marginSM}>
                <Text>Privacy Risk Score</Text>
                <Popover
                  content={privacyRiskContent}
                  placement="bottomLeft"
                  overlayClassName="privacy-risk-info-tooltip"
                  trigger="hover"
                >
                  <InfoCircleOutlined style={{ color: token.colorTextDisabled }} />
                </Popover>
                <Divider type="vertical" size="large" />
                <Button loading={isUpdating} onClick={onMarkAll} type="link" size="small">
                  Mark all as read
                </Button>
              </Flex>
            </div>
          )}
        </div>

        {/* Content area */}
        <div className="tab-content_container">
          <div className="flex_content">
            {/* Filter panel */}
            {isFilterCollapsed && shouldShowUI && (
              <div className="filter-panel">
                <FilterPanel
                  isCollapsed={isFilterCollapsed}
                  alertTypes={alertTypes}
                  metrics={metrics}
                  onApplyFilters={onApplyFilters}
                  appliedFilters={appliedFilters}
                />
              </div>
            )}

            {/* Right panel: collapse or empty */}
            <div id="alerts-list-container"  className='collapse-wrapper' onScroll={onScroll}>
              {isNotificationDataEmpty && !isLoading ? (
                <Empty description="No Alerts" />
              ) : (
                <Spin style={{ marginTop: 100 }} spinning={isLoading} size="large">
                  <Collapse
                    activeKey={activeCollapse}
                    onChange={setActiveCollapse}
                    className="alerts-v2-collapse"
                  >
                    {Object.entries(notificationData).map(([label, data]) =>
                      data?.length ? (
                        <Collapse.Panel key={label} header={label} id={label}>
                          {data.map((item) => (
                            <NotificationDetailsPage
                              key={item.id}
                              onNotificationClick={() =>
                                activeTab === 'new' && markNotificationsRead({ ids: [item.id] })
                              }
                              link={createNotificationLink(item?.type, item?.parameters)}
                              title={generateTitle(item?.type, item?.parameters)}
                              type={getType(item?.type, item?.parameters?.metric)}
                              description={generateDescription(item?.type, item?.parameters)}
                              date={item?.created_at}
                              alertType={item?.type}
                            />
                          ))}
                        </Collapse.Panel>
                      ) : null,
                    )}
                  </Collapse>
                  {isLoadingMore && (
                    <Spin spinning={true} size="large">
                      <div style={{ height: 50 }} />
                    </Spin>
                  )}
                </Spin>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationTabItem;